import styles from "./DetailsTab.module.css";
import PropTypes from "prop-types";
import Card from "../Card";

/**
 *
 * the contents of the Details tab under the tab bar of the Group page
 */

export function DetailsTab({ detailedWorldwideGroupData, dreamStreamData }) {

  const dwwgd = detailedWorldwideGroupData;

  return (
    <>
      <div className={styles.container}>
        <div className={styles.cardContainer}>
          <Card
            title="DETAILED WORLDWIDE GROUP DATA"
            children={
              <div className={styles.grid}>
                <div className={styles.leftColumnItem}>Id:</div>
                <div className={styles.rightColumnItem}>{dwwgd.id}</div>

                <div className={styles.leftColumnItem}>Is_Dreamstream_Default:</div>
                <div className={styles.rightColumnItem}>{dwwgd.isDreamstreamDefault}</div>

                <div className={styles.leftColumnItem}>Is_Community:</div>
                <div className={styles.rightColumnItem}>{dwwgd.isCommunity}</div>

                <div className={styles.leftColumnItem}>Name:</div>
                <div className={styles.rightColumnItem}>{dwwgd.name}</div>

                <div className={styles.leftColumnItem}>Privacy:</div>
                <div className={styles.rightColumnItem}>{dwwgd.privacy}</div>

                <div className={styles.leftColumnItem}>Archived:</div>
                <div className={styles.rightColumnItem}>{dwwgd.archived}</div>

                <div className={styles.leftColumnItem}>Post_Requires_Admin_Approval:</div>
                <div className={styles.rightColumnItem}>{dwwgd.postRequiresAdminApproval}</div>

                <div className={styles.leftColumnItem}>Purpose:</div>
                <div className={styles.rightColumnItem}>{dwwgd.purpose}</div>

                <div className={styles.leftColumnItem}>Post_Permissions:</div>
                <div className={styles.rightColumnItem}>{dwwgd.postPermissions}</div>

                <div className={styles.leftColumnItem}>Join_Settings:</div>
                <div className={styles.rightColumnItem}>{dwwgd.joinSettings}</div>

                <div className={styles.leftColumnItem}>Is_Los_Group:</div>
                <div className={styles.rightColumnItem}>{dwwgd.isLosGroup}</div>

                <div className={styles.leftColumnItem}>Is_Whitelisted:</div>
                <div className={styles.rightColumnItem}>{dwwgd.isWhitelisted}</div>

                <div className={styles.leftColumnItem}>Group_Type:</div>
                <div className={styles.rightColumnItem}>{dwwgd.groupType}</div>

                <div className={styles.leftColumnItem}>Owner_Ibo:</div>
                <div className={styles.rightColumnItem}>{dwwgd.ownerIbo}</div>

                <div className={styles.leftColumnItem}>Group_Plugins:</div>
                <div className={styles.rightColumnItem}>{dwwgd.groupPlugins}</div>

                <div className={styles.leftColumnItem}>Metagroup_Plugins_To_This:</div>
                <div className={styles.rightColumnItem}>{dwwgd.metagroupPluginsToThis}</div>

                <div className={styles.leftColumnItem}>Metagroup_Plugins_From_This:</div>
                <div className={styles.rightColumnItem}>{dwwgd.metagroupPluginsFromThis}</div>
              </div>
            }
          />
        </div>

        <div className={styles.cardContainer}>
          <Card
            title="DREAMSTREAM DATA"
            children={
              <div className={styles.grid}>
                <div className={styles.leftColumnItem}>Id:</div>
                <div className={styles.rightColumnItem}>{dreamStreamData.id}</div>

                <div className={styles.leftColumnItem}>Name:</div>
                <div className={styles.rightColumnItem}>{dreamStreamData.name}</div>

                <div className={styles.leftColumnItem}>Privacy:</div>
                <div className={styles.rightColumnItem}>{dreamStreamData.privacy}</div>

              </div>
            }
          />
        </div>

      </div>
    </>
  );
}

DetailsTab.propTypes = {
  detailedWorldwideGroupData: PropTypes.object,
  dreamStreamData: PropTypes.object,
};
